export const errorMixin = {
    methods: {
        showError(error) {
            const err = error.response;
            this.errorMsg = 'An unknown error occurred. Try again later.';
            if (err.status == 403) {
                this.errorMsg = err.data.detail;
            }
            this.isLoading = false;
        },
        showError400(error) {
            const err = error.response;
            this.errorMsg = 'An unknown error occurred. Try again later.';
            if (err.status == 403) {
                this.errorMsg = err.data.detail;
            } else if (err.status == 400 && err.data.error == 'Account Confirmed') {
                this.errorMsg = err.data.message;
            }
            this.isLoading = false;
        }
    }
};

